import React from "react";
import { buttonActionClassGray } from "helpers/StyleClass";
import PublisherFirstLookModal from "./PublisherFirstLookModal";
import { useAnatomyFilter, useAnatomyData } from "./context/AnatomyContexts";

class PublisherFirstLookButtonInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
    };
  }

  render() {
    const { isOpenModal } = this.state;

    const { unitId, unitName, networkId, startDate, endDate, includeToday } =
      this.props;

    return (
      <>
        <button
          type="button"
          className={buttonActionClassGray}
          onClick={() => this.setState({ isOpenModal: true })}
        >
          Get Applied First Look
        </button>

        {isOpenModal && (
          <PublisherFirstLookModal
            unitId={unitId}
            unitName={unitName}
            networkId={networkId}
            startDate={startDate}
            endDate={endDate}
            includeToday={includeToday}
            onClose={() => this.setState({ isOpenModal: false })}
          />
        )}
      </>
    );
  }
}

const PublisherFirstLookButton = React.memo((props) => {
  const filterContext = useAnatomyFilter();
  const dataContext = useAnatomyData();

  if (!filterContext || !dataContext) {
    return <PublisherFirstLookButtonInner {...props} />;
  }

  return (
    <PublisherFirstLookButtonInner
      {...props}
      unitId={dataContext.unitInfo.gamUnitId}
      unitName={dataContext.unitInfo.name}
      networkId={dataContext.unitInfo.networkId}
      currency={dataContext.unitInfo.currency}
      startDate={filterContext.startDate}
      endDate={filterContext.endDate}
      includeToday={filterContext.includeToday}
    />
  );
});

export default PublisherFirstLookButton;
